import { useQuery } from '@tanstack/react-query';
import { getFooter } from '@/lib/api/common/footer.api';

export const footerQueryKeys = {
  footer: ['footer'] as const,
} as const;

export function useFooterData() {
  const { data, isLoading, error } = useQuery({
    queryKey: footerQueryKeys.footer,
    queryFn: getFooter,
    staleTime: 0,
    gcTime: 0,
    refetchOnWindowFocus: false,
  });

  return { data, isLoading, error };
}
